import { useState } from 'react';

import { Link } from 'react-router-dom';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';
import TextInput from '#globalComponents/Forms/TextInput';
import { useAuth } from '#globalContexts/AuthProvider';

import registerBackground from '../../../../assets/images/register-background.jpg';

const RequestPasswordReset = () => {
	const [formData, setFormData] = useState({ email: '' });
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState(false);
	const { resetPassword } = useAuth();

	const handleFormInput = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

	const handleSubmit = async (e) => {
		e.preventDefault();

		setIsLoading(true);
		setError('');
		setSuccess(false);

		const { error } = await resetPassword(formData.email);

		if (error) {
			setError(error.message);
		} else {
			setSuccess(true);
		}

		setIsLoading(false);
	};

	return (
		<div
			className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center relative"
			style={{
				backgroundImage: `url(${registerBackground})`,
			}}
		>
			{/* Overlay with blur effect */}
			<div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />

			<div className="relative z-10">
				<Card className="p-8 max-w-md w-full mx-4">
					<div className="text-left mb-6">
						<h1 className="text-lg font-bold text-text mb-2">Passwort zurücksetzen</h1>
						<p className="text-text">
							Geben Sie Ihre E-Mail-Adresse ein, um ein neues Passwort anzufordern
						</p>
					</div>

					{error && (
						<div className="bg-red-50 border border-red-200 text-warning-700 px-4 py-3 rounded-lg mb-4">
							{error}
						</div>
					)}
					{success && (
						<div className="bg-green-50 border border-green-200 text-success-700 px-4 py-3 rounded-lg mb-4">
							<div className="flex items-center mb-2">
								<svg className="w-5 h-5 text-success-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
									<path
										fillRule="evenodd"
										d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
										clipRule="evenodd"
									/>
								</svg>
								<span className="font-medium">E-Mail versendet!</span>
							</div>
							<p className="text-sm">
								Falls diese E-Mail-Adresse registriert ist, haben wir Ihnen einen Link zum Zurücksetzen
								Ihres Passworts gesendet.
							</p>
						</div>
					)}

					<form onSubmit={handleSubmit}>
						<div className="mb-6">
							<TextInput
								type="email"
								value={formData.email}
								name="email"
								onChange={handleFormInput}
								placeholder="E-Mail-Adresse"
								required
							/>
						</div>

						<Button type="submit" variant="solid" size="md" fullWidth loading={isLoading}>
							Passwort zurücksetzen
						</Button>
					</form>

					<div className="text-center mt-6">
						<Link
							to="/login"
							className="text-sm text-primary-700 hover:text-primary-700 font-medium flex items-center justify-center"
						>
							<svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M10 19l-7-7m0 0l7-7m-7 7h18"
								/>
							</svg>
							Zurück zur Anmeldung
						</Link>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default RequestPasswordReset;
